import * as React from 'react'
import { ReactElement } from 'react'
import { DocumentCommandBarItemProps, overflowButtonStyles, visibleButtonStyles } from './DocumentCommandBar'
import { DocumentContext, IDocumentStackItemDto, isFolder } from '../../../config/documentConfig'
import { CommandBarButton } from '@fluentui/react'
import OfficeDocumentDialog from '../../Dialog/OfficeDocument/OfficeDocumentDialog'
import DialogButton from '../../Button/DialogButton'
import { DocumentType } from '../../../config/documentConfig'
import { useTranslation } from 'react-i18next'
import { getApplicationIconPropsByType } from '../../../helpers/iconHelper'

type Props = DocumentCommandBarItemProps & {
    name: string
}

export default function OfficeDocumentButton(props: Props): ReactElement {
    const selectedFolder = props.selectedItems.find(isFolder)
    const { t: translate } = useTranslation()

    const disabled = props.isLoading

    return (
        <DialogButton
            button={CommandBarButton}
            buttonProps={{
                disabled,
                iconProps: getApplicationIconPropsByType(props.name.toUpperCase() as DocumentType),
                styles: props.item.renderedInOverflow ? overflowButtonStyles : visibleButtonStyles,
            }}
            dialog={OfficeDocumentDialog}
            dialogProps={{
                dialogContentProps: {
                    title: translate(`file.pivot.document.create.${props.name.toLowerCase()}`),
                },
                context: DocumentContext.Document,
                documentType: DocumentType[props.name],
                selectedFolder,
                folders: props.rootFolder.data,
                reset: (stack?: IDocumentStackItemDto[]) => props.reset(props.sortOrder, stack),
                variables: { file: props.file },
            }}
            tooltipProps={{ content: translate(`file.pivot.document.create.${props.name.toLowerCase()}`) }}
        />
    )
}
